import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OxygenOTPComponent from '../components/OxygenOTPComponent';
import useCustomAlert from "../components/Alert2";
import {oxygenOTP, loanApproval, bookLoan} from "../services/oxygenRetailServices";
import { useNavigate } from 'react-router-dom';
import { hideModal, setShowModal } from '../redux/features/oxygen/customModalSlice';
import {updateCustomerOnboardingStat,} from "../services/PrequalificationService";
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';
import { setOtpLoading } from '../redux/features/oxygen/oxygenRetailSlice';

const OxygenLoanOTP = () => {
  const navigate = useNavigate();
  const customAlert = useCustomAlert();
  const dispatch = useDispatch();
   
  const storePrecustomer = useSelector(
    (state) => state?.precustomer?.precustomerData
  );

  // for oxygen book loan:
  const oxygenBookLoan = async() => {
    const payload = {
      PreCustomerId:storePrecustomer.precustomer?.precustomerId
    }
    
    const res = await bookLoan(payload);

    if(res?.status === true){
      customAlert.showToast("success", `${res?.message}` || "Loan booked successfully");
      dispatch(hideModal());
      navigate("/oxygenLoan-OTP")
    }else{
      customAlert.showToast("error", `${res?.message}` || "Failed to book loan");
    }
  }

  const handleResendOTP = async() =>{
    const res = await oxygenOTP(storePrecustomer?.precustomer?.msisdn);

    if(res.status === true) {
      customAlert.showToast("success", `${res?.message}` ||"OTP sent successfully, please check your phone for OTP"); 
    } else {
      customAlert.showToast("error", `${res?.message}` || "Failed to send OTP");
    }
  };

  const handleProceed = async(otp) =>{
    dispatch(setOtpLoading(true));
    const formData = {
      preCustomerId: Number(storePrecustomer?.precustomer?.precustomerId),
      otp: String(otp), 
    }

    const res = await loanApproval(formData);

    if(res.status === true) {
      dispatch(setOtpLoading(false));
      // Make api call to update the onboarding status
      await updateCustomerOnboardingStat(
        storePrecustomer?.precustomer?.msisdn,
        "LOAN_APPROVED"
      );
      dispatch(
        updatePrecustomer({
          ...storePrecustomer,
          onboarding_status: "oxygenpayment-links",
        })
      )
      customAlert.showToast("success", `${res?.message}` ||"Loan approved successfully");
      
      setTimeout(() => {
        navigate("/oxygenpayment-links"); 
      }, 2000);
    } else {
      dispatch(setOtpLoading(false));
      customAlert.showToast("error", `${res?.message}` || "Failed to approve loan");
      dispatch(setShowModal({
        status:true,
        title:"Book Loan",
        type:"bookLoan",
        showCloseButton:false,
        data:{oxygenBookLoan},
      }));
    }
  };

  const actions = {handleResendOTP:handleResendOTP , handleProceed:handleProceed, consentText:"Enter OTP to Consent To activate your loan"}

  return (
    <div>
      <OxygenOTPComponent {...actions} />
    </div>
  )
}

export default OxygenLoanOTP